import React from 'react'
import PurolatorYourWay from 'components/PurolatorYourWay'
import ImageBanner from 'components/ImageBanner'
import RecipientInfoContent from 'components/RecipientInfoContent'
import styled from 'styled-components'
import { breakpoints } from 'globalStyles'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 30px;
  margin-bottom: 42px;
  @media ${breakpoints.xxs} {
    max-width: 319px;
  }
`

const RecipientInfo = () => {
  return (
    <Container>
      <ImageBanner shipmentStatus="out_for_delivery" />
      <PurolatorYourWay />
      <RecipientInfoContent />
    </Container>
  )
}

export default RecipientInfo
